import React, { useState } from "react";
import TemplateArticleHelp from "../TemplateArticleHelp/TemplateArticleHelp";
import styles from "./Apps.module.css";
import { ReactComponent as GreenDotsAppIcon } from "../../../assets/GreenDotsAppIcon.svg";
import { ReactComponent as ArrowDownBold } from "../../../assets/arrowDownBold.svg";
import { ReactComponent as BlackWarningIcon } from "../../../assets/BlackWarningIcon.svg";
import { ReactComponent as ConectionsGrayIcon } from "../../../assets/ConectionsGrayIcon.svg";
import { ReactComponent as Gmail } from "../../../assets/gmailCircle.svg";
import { ReactComponent as OutlookCircle } from "../../../assets/outlookCircle.svg";
import { ReactComponent as DriveCircle } from "../../../assets/driveCircle.svg";
import { ReactComponent as SharePointCircle } from "../../../assets/sharePointCircle.svg";
import { ReactComponent as OneDriveCircle } from "../../../assets/oneDriveCircle.svg";
import { ReactComponent as Droopbox } from "../../../assets/droopbox.svg";
import { ReactComponent as GestionaEsPubliconNewLogoCircle } from "../../../assets/gestionaEsPubliconNewLogoCircle.svg";
import { ReactComponent as ExcelCircle } from "../../../assets/excelCircle.svg";
import { ReactComponent as AgenciaTributariaCircle } from "../../../assets/agenciaTributariaCircle.svg";
import { ReactComponent as PdfCircle } from "../../../assets/PdfCircle.svg";
import { ReactComponent as OdooCircleNew } from "../../../assets/OdooCircleNew.svg";
import { ReactComponent as A3Circle } from "../../../assets/a3Circle.svg";
import { ReactComponent as HubSportCircleWhite } from "../../../assets/HubSportCircleWhite.svg";
import { ReactComponent as Telematel } from "../../../assets/telematel.svg";
import { ReactComponent as WhatsappCircleWhite } from "../../../assets/WhatsappCircleWhite.svg";
import { ReactComponent as StripeCircleWhite } from "../../../assets/StripeCircleWhite.svg";
import { ReactComponent as HoldedCircleWhite } from "../../../assets/HoldedCircleWhite.svg";
import { ReactComponent as RocketIcon} from "../../../assets/rocketIcon.svg";
import { useTranslation } from "react-i18next";
const App = ({setSelectedCategory}) => {
  const { t } = useTranslation("helpPage");

  const [activeArticles, setActiveArticles] = useState({
    1: true,
    2: true,
    3: true,
    4: true,
    5: true,
    6: true,
  });

  const handleClick = (index) => {
    setActiveArticles((prevState) => ({
      ...prevState,
      [index]: !prevState[index], 
    }));
  };
  const icons = [
    { id: 1, component: <Gmail /> },
    { id: 2, component: <OutlookCircle /> },
    { id: 3, component: <DriveCircle /> },
    { id: 4, component: <SharePointCircle /> },
    { id: 5, component: <OneDriveCircle /> },
    { id: 6, component: <Droopbox /> },
    { id: 7, component: <GestionaEsPubliconNewLogoCircle /> },
    { id: 8, component: <ExcelCircle /> },
    { id: 9, component: <AgenciaTributariaCircle /> },
    { id: 10, component: <PdfCircle /> },
    { id: 11, component: <OdooCircleNew /> },
    { id: 12, component: <A3Circle /> },
    { id: 13, component: <HubSportCircleWhite /> },
    { id: 14, component: <Telematel /> },
    { id: 15, component: <WhatsappCircleWhite /> },
    { id: 16, component: <StripeCircleWhite /> },
    { id: 17, component: <HoldedCircleWhite /> },
  ];
  return (
    <div>
      <TemplateArticleHelp
        title={t("Apps")}
        description={t('AppsDescription')}
        Icon={GreenDotsAppIcon}
        setSelectedCategory={setSelectedCategory}
      >
        <div className={styles.articlesContent}>
          <div className={styles.article}>
            <div
              className={styles.articleTitle}
              onClick={() => handleClick(1)} 
            >
              {t('createYourGPTs')} <ArrowDownBold />
            </div>
            <div
              className={styles.articleInfo}
              style={{
                height: activeArticles[1] ? "auto" : "0px", 
                overflow: "hidden", 
              }}
            >
             {t('AppsInfoDesc')}
              <br />
              <br />
              <BlackWarningIcon /> {t('AppsImportant')}
            </div>
          </div>

          <div className={styles.article}>
            <div
              className={styles.articleTitle}
              onClick={() => handleClick(2)} 
            >
              {t('automate')} <ArrowDownBold />
            </div>
            <div
              className={styles.articleInfo}
              style={{
                height: activeArticles[2] ? "auto" : "0px", 
                overflow: "hidden", 
              }}
            >
              {t('facturagptConnectBusiness')}
              <br />
              <br />
              <div className={styles.ConectionsGrayIcon}>
                <ConectionsGrayIcon />
              </div>
              <div className={styles.iconsLogoContainer}>
                {icons.map((icon) => (
                  <div key={icon.id} className={styles.iconLogos}>
                    {icon.component}
                  </div>
                ))}
              </div>
                <br />
                {t('detailsAvailableSoon')} <RocketIcon height={15} width={15}/>
            </div>
          </div>

          <div className={styles.article}>
            <div
              className={styles.articleTitle}
              onClick={() => handleClick(3)} 
            >
              {t('notifications')} <ArrowDownBold />
            </div>
            <div
              className={styles.articleInfo}
              style={{
                height: activeArticles[3] ? "auto" : "0px", 
                overflow: "hidden", 
              }}
            >
         {t('monitorAutomation')}
              <ul>
                <li>{t('receiveAlerts')}</li>
                <br />
                <br />
              <li>{t('monitorYourTeams')}</li>
              </ul>
              <br />
              <br />
              {t('stayInformed')}
            </div>
          </div>
        </div>
      </TemplateArticleHelp>
    </div>
  );
};

export default App;
